module.exports = __webpack_public_path__ + "static/media/four-flavors-pizza.33532929.svg";